import React from 'react';
import { IRouter } from '@routers/interface';
import { BankOutlined } from '@ant-design/icons';

export const routerDashboard: IRouter = {
  path: '/dashboard',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'dashboard.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  menu: {
    icon: <BankOutlined />,
  },
  permissionCode: 'dashboard',
};
